<script setup lang="ts">
import { UiButton } from '@peanuds/ui';

const { expanded } = defineProps<{
  expanded?: boolean;
}>();

const emit = defineEmits<{
  prev: [];
  next: [];
}>();
</script>

<template>
  <div class="iban-swiper-controls" :class="{ expanded: expanded }">
    <UiButton
      aria-label="Previous IBAN"
      icon="pi pi-angle-left"
      type="button"
      severity="secondary"
      variant="outlined"
      @click="emit('prev')"
    />
    <UiButton
      aria-label="Next IBAN"
      icon="pi pi-angle-right"
      type="button"
      severity="secondary"
      variant="outlined"
      @click="emit('next')"
    />
  </div>
</template>

<style scoped lang="scss">
.iban-swiper-controls {
  display: flex;
  flex-direction: row;
  gap: 0.25rem;

  &.expanded {
    flex-direction: column;
  }

  :deep(.p-button-icon) {
    font-size: $static-text-sm;
  }
}
</style>
